import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WithdrawalLogModel } from '../Models/withdrawal-log.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ElementWithdrawalService {
  private apiUrl = environment.apiBaseUrl + "/ElementWithdrawal"; // API-Pfad anpassen

  constructor(private http: HttpClient) { }

  recordWithdrawal(withdrawalData: {
    elementId: number;
    quantity: number;
    purpose: string;
    comments?: string;
  }): Observable<any> {
    return this.http.post(this.apiUrl, withdrawalData);
  }

  getWithdrawalHistoryByElement(elementId: number): Observable<WithdrawalLogModel[]> {
    return this.http.get<WithdrawalLogModel[]>(`${this.apiUrl}/element/${elementId}`);
  }

  getRecentWithdrawals(count: number = 100): Observable<WithdrawalLogModel[]> {
    return this.http.get<WithdrawalLogModel[]>(`${this.apiUrl}/recent?count=${count}`);
  }

  getMyWithdrawals(): Observable<WithdrawalLogModel[]> {
    return this.http.get<WithdrawalLogModel[]>(`${this.apiUrl}/user`);
  }
}
